import { render, staticRenderFns } from "./Fodbosa.vue?vue&type=template&id=8cf69898&"
import script from "./Fodbosa.vue?vue&type=script&lang=js&"
export * from "./Fodbosa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports